// Get profile
export const GET_CEP_R = '@utils/GET_CEP_R'
export const GET_CEP_S = '@utils/GET_CEP_S'
export const GET_CEP_F = '@utils/GET_CEP_F'
